export default [
    {
        key: 'example_client_feature',
        title: 'Example feature',
        description: 'This is an example of how a feature flag should be created.',
        owner: "René d'Herblay",
        test_value: true,
        default_value: true
    },
    {
        key: 'sensor_placement_readings',
        title: 'Sensor Placement Readings in Form',
        description: 'Get sensor readings by placement in form when using the sensor_question field',
        owner: 'Francisco Tejon',
        test_value: true,
        default_value: true
    },
    {
        key: 'limit_brand_wide_submissions',
        title: 'Limit brand wide submissions view',
        description:
            'Actities now require `permit_brandwide_submission_access` set before they show submissions on the brand wide submission page',
        owner: 'Anže Pečar',
        test_value: true,
        default_value: false
    },
    {
        key: 'push_registration_refactor',
        title: 'Push Notification Registration Refactor',
        description: 'Refactor push notification registration process on mobile to be tested and easier to maintain',
        owner: 'David Watkins',
        test_value: true,
        client: true
    },
    {
        key: 'clientside_invite_flow',
        title: 'Client-Side Invite Flow',
        description: 'Refactor the invite flow to avoid django templating',
        owner: 'Tanweer Rajwani',
        default_value: true,
        test_value: true
    },
    {
        key: 'fix_form_draft_photo_deletion',
        title: 'Fix form draft photo deletion',
        description: 'Fixes the draft photo deletion bug on native',
        owner: 'Sanghyun Lee',
        client: true,
        test_value: true
    },
    {
        key: 'pass_fail_temperature_audio',
        title: 'Sound pass/fail temperature',
        description: 'Play sound on pass/fail behavior for temperature fields',
        owner: 'Diego Dominguez',
        client: true,
        test_value: true
    },
    {
        key: 'avoid_unauthenticated_requests',
        title: 'Avoid unauthenticated requests',
        description: 'Avoid unauthenticated requests in the mobile app login screen',
        owner: 'Paul Guerrero',
        client: true,
        test_value: true,
        default_value: false
    },
    {
        key: 'fix_machineq_qr',
        title: 'Fix MachineQ QR',
        description: 'Handle DevEUI only QRs',
        owner: 'Team Meow',
        client: true,
        test_value: true,
        default_value: false
    },
    {
        key: 'improve_performance_for_list_projects',
        title: 'Improve performance for list_projects endpoint',
        owner: 'Performance teamup',
        client: true,
        test_value: false,
        default_value: true
    },
    {
        key: 'improve_performance_for_list_recurring_projects',
        title: 'Improve performance for recurring list_projects endpoint',
        owner: 'Oscar Martinez',
        client: true,
        test_value: false,
        default_value: true
    },
    {
        key: 'add_project_report',
        title: 'Add new report type Project Report',
        owner: 'Team Meow',
        client: true,
        test_value: true,
        default_value: true
    },
    {
        key: 'add_between_operator_to_location_activity_report',
        title: 'Add between operator to Location Activity report',
        owner: 'Yurii Parfinenko',
        client: true,
        test_value: true,
        default_value: true
    },
    {
        key: 'new_users_page',
        title: 'New Users Page',
        owner: 'Oscar Martinez',
        client: true,
        test_value: false,
        default_value: false
    },
    {
        key: 'set_temp_units_on_userprofile',
        title: 'Set Temperature units on Userprofile',
        owner: 'Yurii Parfinenko',
        client: true,
        test_value: true,
        default_value: true
    },
    {
        key: 'use_local_notifications',
        title: 'Use local notifications',
        owner: 'Yurii & Tejón',
        client: true,
        test_value: true,
        default_value: true
    },
    {
        key: 'allow_follow_up_actions',
        title: 'Allow follow up actions in the form builder',
        owner: 'Alejandro Alcaraz',
        client: true,
        test_value: true,
        default_value: false
    },
    {
        key: 'get_content_type_from_raw_file',
        title: 'Get content type from raw file on mobile web',
        owner: 'Alexandra Gamazina',
        client: true,
        test_value: true,
        default_value: false
    },
    {
        key: 'detect_low_quality_photos',
        title: 'Detect low-quality photos',
        owner: 'Yurii & Tejón',
        client: true,
        test_value: true,
        default_value: true
    }
];
